import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"
import { useMarina } from "src/contexts/MarinaContext"

import Form from "src/components/Form"

import { validatePositiveNumberWithPrecision } from "./helpers"

const PurchasePriceField = ({
  isUpdatingRetailPrice = false,
  pricePrecision,
  accountingV2Enabled = false,
}) => {
  const {
    register,
    formState: { errors },
  } = useFormContext()

  const { currencySymbol } = useMarina()

  return (
    <div className="mt-4">
      <Form.Label htmlFor="purchase-price">
        Purchase price (per unit)
      </Form.Label>
      <Form.IconTextField
        id="purchase-price"
        position="left"
        icon={currencySymbol}
        type="number"
        inputMode="decimal"
        {...register("purchasePrice", {
          required:
            (isUpdatingRetailPrice || accountingV2Enabled) &&
            "Purchase price is required",
          validate: (purchasePrice) =>
            validatePositiveNumberWithPrecision({
              value: purchasePrice,
              precision: pricePrecision,
            }),
        })}
        hasErrors={Boolean(errors.purchasePrice)}
      />
      <Form.Error>{errors.purchasePrice?.message}</Form.Error>
    </div>
  )
}

PurchasePriceField.propTypes = {
  isUpdatingRetailPrice: PropTypes.bool,
  pricePrecision: PropTypes.number.isRequired,
  accountingV2Enabled: PropTypes.bool,
}

export default PurchasePriceField
